import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../shared/services/base.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { JobFilter } from "../../job/models/job.filter";
import { User } from "../../shared/models/user.interface";
import { Invoice } from "../../shared/models/invoice.interface";
import { Router } from "@angular/router";

@Injectable()
export class ExportService extends BaseService {

  constructor(private datepipe: DatePipe, protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getList(filter: JobFilter, sortColumn: string, sortDirection: string): Observable<Invoice[]> {
    let params = new HttpParams();

    if (sortColumn != null) params = params.append('sortColumn', sortColumn);
    if (sortDirection != null) params = params.append('sortDirection', sortDirection);
    if (filter.projectName) params = params.append('projectName', filter.projectName);
    if (filter.convertedDateRange) params = params.append('convertedDateRange', filter.convertedDateRange.toString());
    if (filter.startDateRange) params = params.append('startDateRange', filter.startDateRange.toString());
    if (filter.salespersonId) params = params.append('salespersonId', filter.salespersonId.toString());

    return this.httpGet<Invoice[]>("/export/invoices?" + params.toString());
  }

  getSalespersons(): Observable<User[]> {
    return this.httpGet<User[]>("/user/salesperson");
  }

  downloadInvoices(quoteIds: number[], changeOrderIds: number[]): Observable<Blob> {
    let request = {
      quoteIds: quoteIds,
      changeOrderIds: changeOrderIds
    };

    return this.httpPostFile("/export/invoices", request);
  }
 
}
